export const CMS_PRIMARY = "#007BFF";
export const CMS_PRIMARY_HOVER = "#0069D9";

export const PRIORITY_OPTIONS = ["Low", "Medium", "High"];

export const PRIORITY_STYLES = {
  Low: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  Medium: "bg-amber-50 text-amber-700 border border-amber-200",
  High: "bg-rose-50 text-rose-700 border border-rose-200",
};

export const STATUS_OPTIONS = ["Pending", "In Progress", "Completed"];

export const normalizeTaskStatus = (status, isCompleted = false) => {
  if (isCompleted) return "Completed";

  const value = String(status || "").trim();
  const lower = value.toLowerCase();

  if (lower === "completed") return "Completed";
  if (lower === "in progress" || lower === "inprogress" || lower === "in_progress") {
    return "In Progress";
  }
  if (lower === "pending") return "Pending";

  return STATUS_OPTIONS.includes(value) ? value : "Pending";
};

export const STATUS_STYLES = {
  Pending: "bg-amber-50 text-amber-700 border border-amber-200",
  "In Progress": "bg-blue-50 text-blue-700 border border-blue-200",
  Completed: "bg-emerald-50 text-emerald-700 border border-emerald-200",
};

export const QUICK_SCHEDULE_OPTIONS = [
  { label: "Today", offset: 0 },
  { label: "Tomorrow", offset: 1 },
  { label: "Next week", offset: 7 },
];

export const EMPTY_TASK = (scheduledDate) => ({
  id: null,
  description: "",
  priority: "",
  outcome: "",
  client_id: null,
  completed: false,
  completed_at: null,
  scheduled_date: scheduledDate,
  status: "Pending",
  is_finalized: false,
  created_at: new Date().toISOString(),
});

export const DAILY_LOG_SWEETALERT = {
  editCompleted: {
    title: "Edit this task?",
    text: "This will mark it active again so you can make changes.",
    confirmButtonText: "Yes, Edit",
  },
  delete: {
    title: "Delete this task?",
    text: "This action cannot be undone.",
    confirmButtonText: "Delete",
    isDanger: true,
  },
  bulkComplete: {
    title: "Mark selected tasks as completed?",
    text: "All selected tasks will be marked as completed.",
    confirmButtonText: "Yes, Complete",
  },
  bulkDelete: {
    title: "Delete selected tasks?",
    text: "This action cannot be undone.",
    confirmButtonText: "Delete Selected",
    isDanger: true,
  },
  finalizeInvalid: { title: "Can't finalize yet" },
  finalizeConfirm: {
    title: "Finalize today's log?",
    text: "You won't be able to edit tasks after finalizing.",
    confirmButtonText: "Finalize & Send",
  },
};